export const COLORS = {
  primaryPurple: '#17171e',
  heroBtnBlue: '#5c638b'
}

export const RESUME_URL =
  'https://drive.google.com/file/d/1_JbGxE6P28gOtnav1JkXZgcZBfntiWb6/view?usp=sharing'
